import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import gsap from 'gsap';
import Swiper from '../swiper';
import Card from './card';
import globalAction from '../../actions/global';
import {isIt15, isFreeMail} from '../../utils/util';
import { postDraw } from '../../pages/api';

const Positions = [
    {x: 0},
    {x: 196},
    {x: 394},
    {x: 588},
    {x: 786}
];

function Lottery ({userData, balance, prizes, records, onUseUp, afterLottery, showLoginModal, showMyPrizesModal, toggleUpgradeModal, togglePayModal, toggleRegModal, setCurrPrizeId, toggleWinModal}) {
    const [cardList, setCardList] = useState([]);
    const [canDraw, setCanDraw] = useState(false);
    
    let drawLoading = false;

    const __flopCard = (idx, prizeId) => {
        const list = cardList.concat([]);
        list.forEach((item, index) => {
            if (idx === index) {
                item.prizeId = prizeId;
                item.active = true;
            }
        });
        setCardList(list);
    };

    async function __postDraw(index) {
        const {result} = await new postDraw().fetch();
        drawLoading = false;
        setCanDraw(false);
        if (result.code === 200 && result.result) {
            modify(result.result.to, result, index);
        }
    }

    function modify(num, result, index) {
        switch(num) {
            case 1:
                // 未登录：提示登录
                showLoginModal();
                break;
            case 2:
                toggleRegModal(true);
                break;
            case 3:
                toggleUpgradeModal(true);
                break;
            case 4:
                togglePayModal(true);
                break;
            case 5:
                onUseUp && onUseUp();
                break;
            case 6:
                __flopCard(index, result.result.prizeId);
                setCurrPrizeId(result.result.prizeId);
                setTimeout(() => {
                    toggleWinModal(true);
                }, 1000);
                afterLottery && afterLottery();
                break;
            default:
                break;
        }
    }

    function handleFlop() {
        if (userData && userData.uid) {
            // 免费邮箱：出弹窗注册
            if (isFreeMail(userData.mailType)) {
                toggleRegModal(true);
                return;
            }
            // VIP邮箱-15元以下套餐，出升级提示
            if (isIt15(userData.mailType)) {
                toggleUpgradeModal(true);
                return;
            }
        } else {
            // 未登录：提示登录
            showLoginModal();
            return;
        }
        // 已翻牌2次，出提示
        if (records && records.length >= 2) {
            onUseUp && onUseUp();
            return;
        }

        // 没有抽奖次数，出续费弹窗
        if (balance < 1) {
            togglePayModal(true);
            return;
        }
        // 翻转卡片
        flipCard();
    }

    function flipCard() {
        // 设置5张空牌
        setCardList([{}, {}, {}, {}, {}]);
        setCanDraw(true);
        dealCard();
    }
    // 发牌
    function dealCard() {
        const oCards = document.querySelectorAll('.m-lottery-card');
        gsap.to(oCards, {left: Positions[2].x, duration: 0});
        oCards.forEach((item, index) => {
            gsap.to(oCards[index], {left: Positions[index].x, duration: .5, delay: .5});
        })
    }


    function handleItemClick(index) {
        if (canDraw && !drawLoading) {
            drawLoading = true;
            __postDraw(index);
        }
    }

    function handleShowMyPrizes() {
        if (userData && userData.uid) {
            if (isFreeMail(userData.mailType)) {
                toggleRegModal(true);
                return;
            } else if (isIt15(userData.mailType)) {
                // VIP邮箱-15元以下套餐，出升级提示
                toggleUpgradeModal(true);
                return;
            } else {
                showMyPrizesModal();
            }
        } else {
            showLoginModal();
        }
    }

    useEffect(() => {
        setCardList(prizes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prizes]);

    return (
        <div className="m-lottery">
            <div className="m-lottery-inner">
                <div className="m-lottery-actions">
                    <button onClick={handleFlop}>立即翻牌</button>
                </div>
                <div className="m-lottery-title">
                    即日起至6月30日，VIP邮箱<strong>在本活动页支付/开通满6个月</strong> <br/>
                    可获得1次翻牌次数，每个帐号最多获得2次
                </div>
                <div className="m-lottery-pool f-clear">
                    {
                        cardList.map((item, index) => {
                            return <Card onClick={() => {handleItemClick(index)}} payload={item} active={item.active} index={index} key={index}></Card>
                        })
                    }
                </div>
                <div className="m-lottery-subTitle">* 每个礼品每个帐号只会获得1次</div>
                <div className="m-lottery-swiper-wrap">
                    <div className="m-lottery-swiper">
                        <Swiper></Swiper>
                        <div className="m-lottery-recordBtn" onClick={handleShowMyPrizes}>我的礼品</div>
                    </div>
                </div>
            </div>
            
            {
                balance > 0 && <div className="m-lottery-extra">
                    <div>可翻</div>
                    <div><span>{balance}</span>次</div>
                </div>
            }
        </div>
    );
}


function mapStateToProps(state) {
    return {
        userData: state.global.userData,
        balance: state.global.balance,
        prizes: state.global.prizes,
        records: state.global.records
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setCurrPrizeId(id) {
            dispatch(globalAction.setCurrPrizeId(id));
        },
        showLoginModal() {
            dispatch(globalAction.toggleLoginModal(true));
        },
        showMyPrizesModal() {
            dispatch(globalAction.toggleMyPrizesModal(true))
        },
        toggleUpgradeModal(flag) {
            dispatch(globalAction.toggleUpgradeModal(flag));
        },
        togglePayModal(flag) {
            dispatch(globalAction.togglePayModal(flag));
        },
        toggleRegModal(flag) {
            dispatch(globalAction.toggleRegModal(flag));
        },
        toggleWinModal(flag) {
            dispatch(globalAction.toggleWinModal(flag));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Lottery);